import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import ChatDrawer from "@/components/locanest/ChatDrawer";

export default function MyChats() {
  const { user } = useAuth();
  const [chats, setChats] = useState(null);
  const [chatId, setChatId] = useState(null);

  const load = () => api.get("/chats").then(({ data }) => setChats(data)).catch(() => setChats([]));
  useEffect(() => { if (user) load(); }, [user]);

  if (user?.role === "owner") return <Navigate to="/owner?tab=chats" replace />;

  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-10" data-testid="my-chats-page">
      <div className="text-xs uppercase tracking-[0.25em] text-[#C85A32]">Messages</div>
      <h1 className="font-display text-3xl md:text-4xl mt-2">My Chats</h1>
      {chats === null ? (
        <div className="mt-8 text-sm text-[#5C6B7A]">Loading…</div>
      ) : chats.length === 0 ? (
        <div className="mt-8 bg-[#F0EBE1] rounded-lg p-10 text-center text-[#5C6B7A]" data-testid="chats-empty">
          <MessageCircle className="mx-auto opacity-50" />
          <p className="mt-2">No conversations yet.</p>
          <Link to="/listings" className="text-[#C85A32] font-medium text-sm">Browse listings and message an owner →</Link>
        </div>
      ) : (
        <div className="mt-8 space-y-3" data-testid="chats-list">
          {chats.map((c) => (
            <button key={c.id} onClick={() => setChatId(c.id)} className="w-full text-left bg-[#F0EBE1] rounded-lg p-4 border border-[#1A1F2C]/10 hover:border-[#C85A32]/40 transition" data-testid={`chat-item-${c.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <div className="font-display text-lg truncate">{c.owner_name}</div>
                  <div className="text-xs text-[#5C6B7A] truncate">re: {c.property_title}</div>
                </div>
                <div className="text-right shrink-0">
                  <div className="text-xs text-[#5C6B7A]">{new Date(c.last_at).toLocaleString()}</div>
                  {c.unread_tenant > 0 && <span className="inline-block mt-1 px-2 py-0.5 bg-[#C85A32] text-white text-[10px] rounded-full">{c.unread_tenant} new</span>}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
      <ChatDrawer chatId={chatId} open={!!chatId} onOpenChange={(v) => !v && setChatId(null)} onOpened={load} />
    </div>
  );
}
